/**
 * Returns number with commas
 * @param {number} x  - currency value in dollars or -
 * @returns {string}
 */
export var numberWithCommas = function (x) {
    if (!x) {
        return '-';
    }
    var str = x.toString();
    var parts = [];
    if (str.includes('.')) {
        parts = str.split('.');
        str = parts[0];
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    }
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
/**
* Returns number in currency format
* @param {number} value  - currency value in dollars or -
* @returns {string}
*/
export var currencyFormat = function (value) {
    if (!value) {
        return '-';
    }
    return value && value < 0 ? '-'
        : "$" + numberWithCommas(+(Math.round(value * 100) / 100).toFixed(2));
};
/**
* Returns rounded number in currency format
* @param {number} value  - currency value in dollars or -
* @returns {string}
*/
export var roundedCurrencyFormat = function (value) {
    return currencyFormat(value);
};
/**
* Returns non negative number
* @param {number} value  - return non negative value or -
* @returns {number | string}
*/
export var nonNegativeValue = function (value) {
    if (!value) {
        return '0';
    }
    return value < 0 ? '0' : "" + numberWithCommas(value);
};
/**
* Capitalizes given word
* @param {string} word - word which needs to be capitalize
* @returns
*/
export var capitalize = function (word) {
    if (word) {
        return word[0].toUpperCase() + word.substring(1).toLowerCase();
    }
    return '';
};
/**
* Capitalizes given camel cased word
* @param {string} word - word which needs to be capitalize
* @returns
*/
export var camelCaseToWords = function (word) {
    if (word) {
        var sentence = word.replace(/([A-Z])/g, ' $1');
        return sentence.charAt(0).toUpperCase() + sentence.slice(1);
    }
    return '';
};
/**
* Capitalizes given snake cased word
* @param {string} word - word which needs to be capitalize
* @returns
*/
export var snakeCaseToWords = function (word) {
    if (word) {
        var words = word.split('_');
        return words.map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    }
    return '';
};
/**
* Capitalizes given snake cased word
* @param {string} word - word which needs to be capitalize
* @returns
*/
export var hyphenCaseToWords = function (word) {
    if (word) {
        var words = word.split('-');
        return words.map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    }
    return '';
};
/**
* Returns a number with 2 decimals
* @param {number} value  - value to be converted to decimals
* @returns {number | string}
*/
export var twoDecimals = function (value) {
    if (!value) {
        return '-';
    }
    return value && +(Math.round(value * 100) / 100).toFixed(2);
};
